// @flow
import React, { Component } from 'react';
import radium from 'radium';

import baseballField from '../../static/images/Block2/baseballField.png';
import baseballPlayer from '../../static/images/Block2/baseballPlayer.png';
import school from '../../static/images/Block2/school.png';

const styles = {
  wrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '@media (max-width: 1024px)': {
      flexDirection: 'column',
    },
  },
  baseballFieldWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 40,
  },
  baseballField: {
    width: 300,
    height: 280,
    backgroundImage: `url(${baseballField})`,
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    marginBottom: 25,
    position: 'relative',
  },
  baseballFieldDescriptionBlock: {
    width: 250,
    height: 40,
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#528B36',
    backgroundColor: 'white',
    position: 'relative',
    '@media (max-width: 414px)': {
      width: 200,
      marginLeft: 24,
    },
  },
  baseballPlayerOuterBox: {
    width: 50,
    height: 50,
    borderRadius: 8,
    padding: 3,
    backgroundColor: '#79B352',
    position: 'absolute',
    left: -31,
  },
  baseballPlayerInnerBox: {
    width: 44,
    height: 44,
    borderRadius: 8,
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  baseballPlayer: {
    width: 35,
    height: 35,
  },
  scoreBlock: {
    width: 40,
    height: 22,
    borderRadius: 4,
    backgroundColor: '#F6F298',
    color: '#EA6161',
    position: 'relative',
    top: -31,
    left: -6,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 13,
    fontWeight: 600,
  },
  houseScoreBlock: {
    padding: 6,
    borderRadius: 4,
    backgroundColor: '#F6F298',
    color: '#EA6161',
    position: 'absolute',
    top: -13,
    left: 56,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 13,
    fontWeight: 600,
    zIndex: 999,
  },
  triangleDown: {
    width: 0,
    height: 0,
    borderLeft: '3px solid transparent',
    borderRight: '3px solid transparent',
    borderTop: '8px solid #F6F298',
    position: 'absolute',
    bottom: -8,
  },
  triangleUp: {
    width: 0,
    height: 0,
    borderLeft: '3px solid transparent',
    borderRight: '3px solid transparent',
    borderBottom: '8px solid #F6F298',
    position: 'absolute',
    top: -8,
  },
  animationBaseballPlayer: {
    width: 35,
    height: 35,
    backgroundImage: `url(${baseballPlayer})`,
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    position: 'absolute',
    left: 135,
    bottom: 30,
    transitionProperty: 'left, bottom',
    transitionDuration: '0.3s',
    transitionTimingFunction: 'linear',
  },
  houseWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 40,
    position: 'relative',
  },
  houseOuterBlock: {
    width: 310,
    height: 160,
    backgroundColor: 'white',
    padding: 10,
    borderRadius: 20,
    marginBottom: 70,
  },
  houseInnerBlock: {
    width: 290,
    height: 140,
    backgroundColor: '#79B352',
    borderRadius: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },
  houseDescriptionBlock: {
    width: 340,
    height: 40,
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#528B36',
    backgroundColor: 'white',
    position: 'relative',
    marginBottom: -73,
    '@media (max-width: 414px)': {
      width: 280,
      marginLeft: 24,
    },
  },
  houseOuterBox: {
    width: 50,
    height: 50,
    borderRadius: 8,
    padding: 3,
    backgroundColor: '#79B352',
    position: 'absolute',
    left: -23,
    '@media (max-width: 414px)': {
      left: -23,
    },
  },
  houseInnerBox: {
    width: 44,
    height: 44,
    borderRadius: 8,
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  house: {
    width: 35,
    height: 35,
  },
  progressBar: {
    width: 270,
    height: 26,
    backgroundColor: 'rgb(108, 109, 110)',
    position: 'relative',
    borderRadius: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },
  progressBarFilled: {
    width: 0,
    height: '100%',
    position: 'absolute',
    left: 0,
    backgroundColor: '#EE8356',
    zIndex: 1,
    borderTopLeftRadius: 10,
    borderBottomLeftRadius: 10,
    transitionDuration: '0.3s',
    transitionDelay: '0.6s',
    transitionProperty: 'width',
    transitionTimingFunction: 'linear',
  },
  line: {
    position: 'absolute',
    height: 18,
    width: 3,
    backgroundColor: 'white',
    zIndex: 2,
  },
  animationSchool: {
    height: 82,
    position: 'absolute',
    bottom: -9,
    left: 0,
    zIndex: 3,
    transitionDuration: '0.7s',
    transitionDelay: '0.6s',
    transitionProperty: 'left',
    transitionTimingFunction: 'linear',
  },
  desc: {
    '@media (max-width: 414px)': {
      fontSize: 13,
    },
  },
};

const ONE_CIRCLE = 1000;
const ONE_PROGRESS = 10000;
const BASE_LENGTH = 250;
const TRIANGLE_HEIGHT = 70;
const TRIANGLE_WIDTH = 75;
const MAX_SCORE = 100000;

const basePositions = [
  {
    score: 0,
    left: 135,
    bottom: 30,
  },
  {
    score: 250,
    left: 210,
    bottom: 100,
  },
  {
    score: 500,
    left: 135,
    bottom: 170,
  },
  {
    score: 750,
    left: 60,
    bottom: 100,
  },
  {
    score: 1000,
    left: 135,
    bottom: 30,
  },
];

// type Props = {
//   currentScore: number,
// };

class AnimationBlock extends Component {
  static ANIMATION_GAP = 300;

  constructor(props) {
    super(props);

    this.animateBox = React.createRef();
    this.baseballHead = React.createRef();

    this.scrollListener = () => this.updateAnimationState();
    this.resizeListener = () => this.updateAnimationState();

    this.state = {
      executeAnimation: false,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.resizeListener);
    window.addEventListener('scroll', this.scrollListener);
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      executeAnimation,
    } = prevState;
    const {
      executeAnimation: currentexecuteAnimation,
    } = this.state;
    const {
      currentScore,
    } = this.props;

    if (currentexecuteAnimation === false && executeAnimation === true) {
      this.baseballHead.current.style.left = '135px';
      this.baseballHead.current.style.bottom = '30px';
    }

    if (currentexecuteAnimation === true && executeAnimation === false) {
      const position = this.calPosition(currentScore % ONE_CIRCLE);

      if (position) {
        this.startBaseballFieldAnimation(position);
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.scrollListener);
    window.removeEventListener('resize', this.resizeListener);
  }

  updateAnimationState() {
    const element = document.scrollingElement || document.documentElement;
    const elementTop = element.scrollTop + window.innerHeight;
    const animateBox = this.animateBox.current;
    const animateTop = animateBox.offsetTop + AnimationBlock.ANIMATION_GAP;

    this.setState({
      executeAnimation: elementTop >= animateTop,
    });
  }

  calPosition(score) {
    const isOnBase = score % BASE_LENGTH === 0;

    const runTimes = score === 0 ? 0 : Math.ceil(score / BASE_LENGTH);

    if (runTimes === 0) return null;

    let position;

    if (!isOnBase) {
      const prevBase = basePositions[runTimes - 1];
      const nextBase = basePositions[runTimes];

      if (prevBase && nextBase) {
        const yPosition = score > BASE_LENGTH ? ((score - prevBase.score) * TRIANGLE_HEIGHT) / BASE_LENGTH : (score * TRIANGLE_HEIGHT) / BASE_LENGTH;
        const proportion = yPosition / TRIANGLE_HEIGHT;

        const baseLeftGap = nextBase.left - prevBase.left;
        const baseBottomGap = nextBase.bottom - prevBase.bottom;

        const finalPosition = {
          score,
          left: baseLeftGap > 0 ? prevBase.left + (TRIANGLE_WIDTH * proportion) : prevBase.left - (TRIANGLE_WIDTH * proportion),
          bottom: baseBottomGap > 0 ? prevBase.bottom + (TRIANGLE_HEIGHT * proportion) : prevBase.bottom - (TRIANGLE_HEIGHT * proportion),
        };

        position = basePositions.slice(0, runTimes);
        position.push(finalPosition);
      }
    } else {
      position = basePositions.slice(0, runTimes + 1);
    }

    return position;
  }

  startBaseballFieldAnimation(position) {
    if (position && position.length) {
      position.forEach((x, index) => {
        setTimeout(() => {
          this.baseballHead.current.style.left = `${x.left}px`;
          this.baseballHead.current.style.bottom = `${x.bottom}px`;
        }, index * 600);
      });
    }
  }

  render() {
    const {
      executeAnimation,
    } = this.state;

    const {
      currentScore: score,
    } = this.props;

    const currentScore = Math.min(score, MAX_SCORE);
    const reachSchool = Math.floor(currentScore / ONE_CIRCLE);

    return (
      <div style={styles.wrapper} ref={this.animateBox}>
        <div style={styles.baseballFieldWrapper}>
          <div style={styles.baseballField} src={baseballField} alt="棒球場">
            <div ref={this.baseballHead} style={[styles.animationBaseballPlayer]} src={baseballPlayer} alt="棒球選手的頭">
              <div style={styles.scoreBlock}>
                {score % ONE_CIRCLE}
                <div style={styles.triangleDown} />
              </div>
            </div>
          </div>
          <div style={styles.baseballFieldDescriptionBlock}>
            <div style={styles.baseballPlayerOuterBox}>
              <div style={styles.baseballPlayerInnerBox}>
                <img style={styles.baseballPlayer} src={baseballPlayer} alt="棒球選手的頭" />
              </div>
            </div>
            <p style={styles.desc}>
              每 1000 次互動跑回本壘
            </p>
          </div>
        </div>
        <div style={styles.houseWrapper}>
          <div style={styles.houseScoreBlock}>
            已達成 {reachSchool} 所
            <div style={styles.triangleDown} />
          </div>
          <div style={styles.houseOuterBlock}>
            <div style={styles.houseInnerBlock}>
              <div style={styles.progressBar}>
                <div style={[styles.line, { left: 27 }]} />
                <div style={[styles.line, { left: 54 }]} />
                <div style={[styles.line, { left: 81 }]} />
                <div style={[styles.line, { left: 108 }]} />
                <div style={[styles.line, { left: 135 }]} />
                <div style={[styles.line, { left: 162 }]} />
                <div style={[styles.line, { left: 189 }]} />
                <div style={[styles.line, { left: 216 }]} />
                <div style={[styles.line, { left: 243 }]} />
                <div
                  style={[
                    styles.progressBarFilled,
                    executeAnimation ? {
                      width: Math.floor(currentScore / ONE_PROGRESS) * 27,
                    } : null,
                  ]} />
                <img
                  style={[
                    styles.animationSchool,
                    executeAnimation ? {
                      left: Math.min(Math.floor(currentScore / ONE_PROGRESS) * 27, 172),
                    } : null,
                  ]}
                  src={school}
                  alt="學校" />
              </div>
              <p style={{
                padding: 6,
                position: 'absolute',
                bottom: 0,
                right: 10,
                borderRadius: 4,
                backgroundColor: '#F6F298',
                color: '#EA6161',
                fontSize: 13,
                fontWeight: 600,
              }}>
                <div style={styles.triangleUp} />
                還剩下 {100 - reachSchool} 所
              </p>
            </div>
          </div>
          <div style={styles.houseDescriptionBlock}>
            <div style={styles.houseOuterBox}>
              <div style={styles.houseInnerBox}>
                <img style={styles.house} src={school} alt="學校" />
              </div>
            </div>
            <p style={styles.desc}>
              每跑回本壘 1 次即達成一所學校祝福
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default radium(AnimationBlock);
